import { Link } from "react-router-dom";
import { Mail } from "lucide-react";

export default function Contact() {
  return (
    <main className="min-h-screen bg-slate-950 px-4 py-16 text-white">
      <div className="mx-auto max-w-2xl">
        <Link to="/" className="text-sm text-white/60 underline hover:text-white">&larr; Back to AnoteQuest</Link>

        <div className="mt-8 rounded-2xl border border-white/20 bg-white/10 p-8 shadow-2xl backdrop-blur-xl sm:p-10">
          <p className="text-sm font-semibold uppercase tracking-wider text-amber-300">Contact</p>
          <h1 className="mt-3 text-4xl font-semibold">Need a hand?</h1>
          <p className="mt-4 leading-7 text-white/80">
            Whether it's a bug, a billing question, or feedback on AnoteQuest, reach out and I'll get
            back to you as soon as I can.
          </p>

          <a
            href="mailto:support@anotequest.com"
            className="mt-8 inline-flex min-h-12 items-center gap-2 rounded-md bg-white px-6 py-3 text-sm font-semibold text-slate-950 shadow-xl transition hover:bg-white/90 focus:outline-none focus:ring-2 focus:ring-white/80"
          >
            <Mail className="h-4 w-4" />
            support@anotequest.com
          </a>

          <p className="mt-6 text-sm text-white/60">
            Looking for our{" "}
            <Link to="/terms" className="underline hover:text-white">Terms and Conditions</Link>
            {" "}or{" "}
            <Link to="/privacy" className="underline hover:text-white">Privacy Policy</Link>?
          </p>
        </div>
      </div>
    </main>
  );
}
